module.exports = __webpack_public_path__ + "static/media/Bastet.35ad45ec.png";